import Vue from 'vue'

// components/commonのGlXxxxxは全て登録
const requireComponent = require.context(
  './components/common',
  false,
  /Gl[\w-]+\.vue$/,
)
requireComponent.keys().forEach(fileName => {
  const componentConfig = requireComponent(fileName)

  // Get PascalCase name of component
  const componentName = fileName.replace(/^\.\//, '').replace(/\.\w+$/, '')

  Vue.component(componentName, componentConfig.default || componentConfig)
})
